const consecutiveSpaces = / +/g;
const singleSpace = ' ';

// Trims trailing, leading, and consecutive spaces
export default (input?: string) => input && input.trim().replace(consecutiveSpaces, singleSpace);
